<template>
  <div>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.title"
      clearable
      placeholder="请输入标题或ID"
    ></el-input>

    <el-date-picker
      size="mini"
      v-model="query.begin_at"
      type="datetime"
      placeholder="选择开课时间"
    >
    </el-date-picker>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.live_type"
      clearable
      placeholder="直播类型"
    >
      <el-option label="全部类型" value="">全部类型</el-option>
      <el-option label="常规直播" value="1">常规直播</el-option>
      <el-option label="推流直播" value="4">推流直播</el-option>
      <el-option label="伪直播" value="6">伪直播</el-option>
      <el-option label="小鹅通直播" value="7">小鹅通直播</el-option>
    </el-select>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.live_status"
      clearable
      placeholder="直播状态"
    >
      <el-option label="全部直播状态" value="">全部直播状态</el-option>
      <el-option label="未开始" value="3">未开始</el-option>
      <el-option label="直播中" value="1">直播中</el-option>
      <el-option label="已结束" value="2">已结束</el-option>
    </el-select>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.status"
      clearable
      placeholder="课程状态"
    >
      <el-option label="全部课程状态" value="">全部课程状态</el-option>
      <el-option label="已发布" value="1">已发布</el-option>
      <el-option label="未发布" value="2">未发布</el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.course_category_id"
        placeholder="请选择分类"
        clearable
    >
      <el-option label="全部分类" value="-1"></el-option>
      <el-option
          v-for="item in categoryList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      >
      </el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.teacher_id"
        placeholder="请选择讲师"
        clearable
        filterable
    >
      <el-option label="全部讲师" value="-1"></el-option>
      <el-option
          v-for="item in teacherList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      >
      </el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.sort"
        clearable
        placeholder="按排序排序"
    >
      <el-option label="按排序排序" value="">按排序排序</el-option>
      <el-option label="倒序排列" value="1">倒序排列</el-option>
      <el-option label="正序排列" value="2">正序排列</el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.released_at"
        clearable
        placeholder="按发布时间排序"
    >
      <el-option label="按发布时间排序" value="">按发布时间排序</el-option>
      <el-option label="倒序排列" value="1">倒序排列</el-option>
      <el-option label="正序排列" value="2">正序排列</el-option>
    </el-select>

    <el-select
        class="search-el"
        size="mini"
        v-model="query.right_mark_symbol"
        clearable
        placeholder="是否精选"
    >
      <el-option label="是否为精选" value="">是否为精选</el-option>
      <el-option label="是" value="1">是</el-option>
      <el-option label="否" value="0">否</el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getListQuery()"> 查询 </el-button>
    <el-button type="primary" size="mini" @click="toCreate()"> 添加 </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column label="标题" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="toCreate(row.id, row.period_id, row.live_type)"
            >
              <div>{{ row.title }}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>
        <el-table-column label="封面大图" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <img :src="row.large_cover_image" style="width: 40px;" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="价格" align="center" min-width="10%">
          <template slot-scope="{ row }">
            {{ row.is_discount == 0 ? "原价" : "优惠价" }}<br />
            人民币： {{ row.is_discount == 0 ? row.price : row.discount_price
            }}<br />
            学习币：
            {{ row.is_discount == 0 ? row.ios_price : row.ios_discount_price }}
          </template>
        </el-table-column>

        <el-table-column label="排序" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="直播时间" align="center" min-width="15%">
          <template slot-scope="{ row }">
            {{
              formatDateTime(row.begin_at, "yyyy-MM-dd hh:mm") +
              " ~ " +
              formatDateTime(row.end_at, "hh:mm")
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="released_at"
          label="发布时间"
          align="center"
          min-width="12%"
        ></el-table-column>

        <el-table-column label="会员免费" align="center" min-width="6%">
          <template slot-scope="{ row }">
            {{ row.level_id > 0 ? "是" : "否" }}
          </template>
        </el-table-column>

        <el-table-column label="直播类型" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <span v-if="row.live_type == 1">常规直播</span>
            <span v-if="row.live_type == 4">推流直播</span>
            <span v-if="row.live_type == 5">带货直播</span>
            <span v-if="row.live_type == 6">伪直播</span>
            <span v-if="row.live_type == 7">小鹅通直播</span>
          </template>
        </el-table-column>

        <el-table-column label="直播状态" align="center" min-width="6%">
          <template slot-scope="{ row }">
            <span v-if="row.live_status == 0">未开始</span>
            <span v-if="row.live_status == 1">直播中</span>
            <span v-if="row.live_status == 2">已结束</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a;"
                ><i class="el-icon-circle-check"></i> 已发布</span
              >
              <span v-else style="color: #909399;"
                ><i class="el-icon-circle-close"></i> 未发布</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px;"
                @click="
                  row.status == 1
                    ? updateStatus(row.id, 0)
                    : updateStatus(row.id, 1)
                "
              >
                {{ row.status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="精选状态" align="center" width="100">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.right_mark_symbol == 1" style="color: #67c23a;">
                精选</span
              >
              <span v-else style="color: #909399;"> 无精选</span>
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px;"
                @click="
                  row.right_mark_symbol == 1
                    ? updateRightMarkSymbol(row.id, 0)
                    : updateRightMarkSymbol(row.id, 1)
                "
              >
                {{ row.right_mark_symbol == 1 ? "删除" : "加精选" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column label="分类" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ filterCategory(row.course_category_id) }}</div>
          </template>
        </el-table-column> -->

        <el-table-column
          prop="course_category_id"
          label="分类"
          align="center"
          min-width="8%"
        >
          <template slot-scope="{ row }">
            <el-select
              ref="multiSelect"
              class="search-el"
              size="mini"
              v-model="row.course_category_id"
              placeholder="请选择分类"
              filterable
              @change="changeCourseAttribute($event, row.id, 'course_category_id', '分类')"
            >
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column
          prop="teacher_id"
          label="讲师"
          align="center"
          min-width="8%"
        >
          <template slot-scope="{ row }">
            <el-select
              ref="multiSelect"
              class="search-el"
              size="mini"
              v-model="row.teacher_id"
              placeholder="请选择讲师"
              filterable
              @change="changeCourseAttribute($event, row.id, 'teacher_id', '讲师')"
            >
              <el-option
                v-for="item in teacherList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="20%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="del(row.id)">
              删除
            </el-button>
            <el-button
              v-show="[1, 4, 6].indexOf(row.live_type) >= 0"
              type="primary"
              size="mini"
              @click="toManager(row.id, row.period_id)"
            >
              管理
            </el-button>
            <el-button
              v-show="[7].indexOf(row.live_type) >= 0"
              type="primary"
              size="mini"
              @click="syncELive(row.id, row.period_id)"
            >
              同步小鹅通
            </el-button>
            <el-button type="primary" size="mini" @click="viewURL(row.id)">
              分享
            </el-button>
            <el-button
              v-show="[1, 4, 6].indexOf(row.live_type) >= 0"
              type="primary"
              size="mini"
              @click="toSetPresent(row.id)"
            >
              设置买赠
            </el-button>
            <el-button type="primary" size="mini" @click="toOrderList(row.id)">
              订单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <!-- 二维码弹窗 -->
    <el-dialog title="直播课程地址" :visible.sync="dialogVisible2" width="50%">
      <el-input
        v-model="liveURL"
        style="width: 66%; margin-left: 256 /2; position: relative; left: 10%;"
      ></el-input>
      <div
        id="qrcode"
        style="margin-left: 256 /2; position: relative; left: 10%;"
      ></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="copy(liveURL)">复制</el-button>
        <el-button
          type="primary"
          @click="
            dialogVisible2 = false;
            liveURL = '';
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getList,
  updateStatus,
  updateRightMarkSymbol,
  del,
  updateSort,
  getLiveURL,
  syncELive
} from "@/api/live";

import {
  changeCourseAttribute
} from "@/api/course";

import { formatDateTime, qrCode, copyData, getCategoryList, getTeacherList } from "@/api/common";

export default {
  data: function () {
    return {
      liveURL: "",
      dialogVisible2: false,
      dialogVisible: false,
      list: [],
      categoryList: [],
      categoryList2: [],
      teacherList: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 10,
        title: this.$route.query.target_id,
        begin_at: "",
        status: "",
        live_type: "",
        live_status: "",
        course_category_id: "-1",
        teacher_id: "-1",
        sort: "",
        released_at: "",
        right_mark_symbol: "",
      },
    };
  },
  created: function () {
    this.getList();
    getCategoryList({type_code: "courselive"}).then((response) => {
      this.categoryList = response.data;
      response.data.forEach((item) => {
        this.categoryList2[item.id] = item.name;
      });
    });
    getTeacherList().then((response) => {
      this.teacherList = response.data;
    });
  },
  methods: {
    toOrderList(id) {
      var path = '?c=order&m=order_course_list&type=5&id=' + id + '&p=51';
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open('http://dev.admin.defen.hzxinquanzi.com/' + path, '_blank');
      } else {
        window.open('http://admin.defen.hzxinquanzi.com/' + path, '_blank');
      }
    },

    changeCourseAttribute(event, id, attribute, text) {
      this.$confirm("确定要更改"+text+"吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        changeCourseAttribute({
          id: id,
          attribute: attribute,
          value: event
        })
          .then((response) => {
            if (response.status == 2000) {
              // setTimeout(() => {
              //   this.$refs.multiSelect.blur();
              // }, 50);
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
      }).catch(() => {});
    },
    filterCategory(category_id) {
      return this.categoryList2[category_id];
    },
    copy(url) {
      copyData(url);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    toSetPresent(id) {
      this.$router.push({
        path: "/order/presentRelationship",
        query: {
          item_type: 5,
          target_id: id,
          object_id: 0,
        },
      });
    },
    viewURL(id) {
      getLiveURL({
        id: id,
      }).then((response) => {
        if (response.status == 2000) {
          this.dialogVisible2 = true;
          this.$nextTick(function () {
            document.getElementById("qrcode").innerHTML = "";
            this.liveURL = response.data.url;
            let qrcode = qrCode(response.data.url, 300, 300);
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    syncELive(course_id, period_id) {
      this.loading = true;
      syncELive({ course_id: course_id, period_id: period_id }).then(
        (response) => {
          this.loading = false;
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "同步成功",
              type: "success",
            });
          }
        }
      );
    },

    formatDateTime(datetime, fmt) {
      return formatDateTime(datetime, fmt);
    },
    toCreate(id = 0, period_id = 0, live_type = 1) {
      if (live_type == 7) {
        this.$message({
          showClose: true,
          message: "小鹅通直播课不需要编辑，点击右侧 同步 按钮即可",
          type: "warn",
        });
      } else {
        if (id > 0) {
          if (window.location.host == 'dev.backend.zhangdefenspace.com') {
            window.open('http://dev.admin.defen.hzxinquanzi.com/?c=live&m=update&id='+id+'&period_id='+period_id+'&p=51', '_blank');
          } else if (window.location.host == 'backend.zhangdefenspace.com') {
            window.open('http://admin.defen.hzxinquanzi.com/?c=live&m=update&id='+id+'&period_id='+period_id+'&p=51', '_blank');
          } else {
            this.$router.push({
              path: "/live/info",
              query: {
                id: id,
                period_id: period_id,
              },
            });
          }
        } else {
          this.$router.push({
            path: "/live/info",
            query: {
              id: id,
              period_id: period_id,
            },
          });
        }
        
      }
    },
    toManager(id, period_id) {
      this.$router.push({
        path: "/live/manage",
        query: {
          id: id,
          period_id: period_id,
        },
      });
    },

    getListQuery(){
      this.query.page = 1
      this.getList()
    },

    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          updateSort({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    updateStatus(id, status) {
      updateStatus({
        id: id,
        status: status,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    updateRightMarkSymbol(id, type) {
      let msgSymbol = '设置成功';
      if(type == 1){
        msgSymbol = '精选成功';
      }
      updateRightMarkSymbol({
        id: id,
        type: type,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: msgSymbol,
            type: "success",
          });
        } /*else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }*/
      });
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        del({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>
